"use client"
import { Fragment, useMemo } from 'react';
import { useIntl } from 'react-intl';
import { Account } from './Account';
import ChangePassword from './ChangePassword';
import { YourCurrentPlan } from './YourCurrentPlan';
const Profile = ({ membership }: any) => {
    const intl = useIntl();

    const hasPaidMembership = useMemo(() => {
        if (!Array.isArray(membership)) return false;
        return membership.some((item: any) => {
            const price = item?.data?.membership?.price;
            return price && Number(price) > 0;
        });
    }, [membership]);

    return (
        <Fragment>
            <div className="grid gap-5 lg:gap-7.5">
                {!hasPaidMembership && ( <YourCurrentPlan /> )}
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 lg:gap-7.5">
                    <div className="col-span-1">
                        <div className="flex flex-col gap-5 lg:gap-7.5">
                            <Account title={intl.formatMessage({ id: "PROFILE.ACCOUNT" })} />
                        </div>
                    </div>
                    <div className="col-span-1">
                        <div className="flex flex-col gap-5 lg:gap-7.5">
                            <ChangePassword />
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export { Profile };
